import { transformDateString } from '../helpers';

const review = data => {
  var _data$userData;

  if (!data || Object.keys(data).length === 0 || !data.userData || !((_data$userData = data.userData) != null && _data$userData.name)) return null;
  return {
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: data.userData.name
    },
    datePublished: transformDateString(data.submissionDate),
    reviewBody: data.description,
    name: data.title,
    reviewRating: {
      '@type': 'Rating',
      bestRating: '5',
      ratingValue: data.rating.toString(),
      worstRating: '1'
    }
  };
};

export default review;